import React from 'react';
import { CopyToClipboard, RocketImage } from 'src/assets/images';
import { Tooltip } from 'src/components';
import { GeneratePaymentRequestWizardPageProps } from 'src/containers/self-service/generate-payment-request/components/GeneratePaymentRequestWizard';
import { PaymentRequestTealiumService } from 'src/containers/self-service/generate-payment-request/tagging/payment-request-tealium-service';
import { Divider } from 'src/features/common';
import { NotificationMethod } from 'src/services/payment-request-service';
interface ITransactionItemProps {
  title: string;
  value?: string;
}

const TransactionItem = ({ title, value }: ITransactionItemProps) => {
  const copyUuidToClipboard = () => navigator.clipboard.writeText(value || '');

  return (
    <div className="md:grid md:grid-cols-2">
      <h2 className="text-base font-medium">{title}:</h2>
      <div className="flex flex-wrap items-center flex-1 gap-4 text-sm md:flex-nowrap text-white-50">
        <p className="">{value}</p>
        {/* @ts-ignore */}
        <Tooltip content="Copied!" showOnClick copyToClipboard>
          <img
            className="!w-4 !h-4  !max-w-4 cursor-pointer"
            onClick={copyUuidToClipboard}
            src={CopyToClipboard}
            alt="Copy"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export function PaymentRequestSent({
  paymentResult,
  notificationAddress,
  notificationMethod,
  paymentType,
  setOnNextEventHandler,
}: GeneratePaymentRequestWizardPageProps) {
  React.useEffect(() => {
    PaymentRequestTealiumService.onRequestSent(notificationMethod, paymentType);

    setOnNextEventHandler(() => {
      PaymentRequestTealiumService.onRequestSentDone(notificationMethod);
    });
  }, []);

  return (
    <div className="flex flex-col items-center gap-10 mt-6">
      <img className="w-24" src={RocketImage} alt="Rocket image" />
      <section className="flex justify-center text-center">
        <div>
          <h1 className="mb-4 text-base md:text-[25px] font-medium">
            Payment Request has been sent successfully!
          </h1>
          <p className="text-xs font-normal text-center md:text-lg">
            {notificationMethod === NotificationMethod.Email
              ? 'An email has been sent to'
              : 'An SMS has been sent to'}
          </p>
          <p className="text-base font-medium text-center md:text-lg">{notificationAddress}</p>
        </div>
      </section>

      <section className="md:w-[500px] w-full pb-16 flex flex-col gap-4">
        <TransactionItem title="TransactionID" value={paymentResult?.transactionId} />
        <Divider />
        <TransactionItem title="Transaction URL" value={paymentResult?.paymentLink} />
      </section>
    </div>
  );
}
